module.exports = __webpack_public_path__ + "img/3moblie.4bd23462.png";